import {whiteListByPermission, Env} from '@hconnect/common/hproduce'
import {hpTheme, ErrorBoundary, Loader} from '@hconnect/uikit/src/lib2'
import {useUpmPlantsContext} from '@hconnect/upm'
import {
  FundamentalContextProvider,
  ThemeProvider as FundamentalThemeProvider,
  ToastContainer
} from '@hm/fundamental'
import {usePermissionsParsedQuery} from '@hproduce/permissions'
import {Box, CircularProgress, CssBaseline, ThemeProvider} from '@mui/material'
import {LocalizationProvider} from '@mui/x-date-pickers'
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment'
import {Suspense} from 'react'

import {FundamentalThemeInitializer} from '../components/FundamentalThemeInitializer'
import {GlobalContextProvider, State} from '../hooks/useGlobalContext'

export const AppProviders: React.FC<{children: React.ReactNode}> = ({children}) => {
  const upmPlants = useUpmPlantsContext({isInitialLoad: true})

  const {data: permissions, error: permissionsError} = usePermissionsParsedQuery()

  if (permissionsError) {
    throw new Error(permissionsError?.message || 'Unknown error')
  }

  if (!upmPlants || !permissions) {
    return <Loader height="100vh" />
  }

  const whiteList = whiteListByPermission(
    process.env.REACT_APP_STAGE as Env,
    permissions,
    upmPlants
  )

  const initContextState: State = {
    whiteList,
    permissions
  }

  return (
    <FundamentalContextProvider>
      <FundamentalThemeProvider>
        <FundamentalThemeInitializer />
        <ThemeProvider theme={hpTheme}>
          <Suspense
            fallback={
              <Box
                sx={{
                  display: 'flex',
                  height: '100vh',
                  width: '100vw',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <CircularProgress color="secondary" size={80} />
              </Box>
            }
          >
            <GlobalContextProvider initialState={initContextState}>
              <ErrorBoundary apology="Something went wrong." resetText="Click here to refresh">
                <CssBaseline />
                <ToastContainer />
                <LocalizationProvider dateAdapter={AdapterMoment}>{children}</LocalizationProvider>
              </ErrorBoundary>
            </GlobalContextProvider>
          </Suspense>
        </ThemeProvider>
      </FundamentalThemeProvider>
    </FundamentalContextProvider>
  )
}
